import { gsap, ScrollTrigger } from "gsap/all"

gsap.registerPlugin(ScrollTrigger)

export const onRouteUpdate = ({ location, prevLocation }) => {
  // Hash-only changes (header links to /#services etc. on the home page)
  // keep the same page mounted, so its triggers must survive
  if (prevLocation && prevLocation.pathname === location.pathname) return
  ScrollTrigger.getAll().forEach(t => t.kill())
  ScrollTrigger.clearMatchMedia()
}

// Section links (/#services etc.) from other pages: open the page at the top,
// then glide down to the section
export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  const el = location.hash && document.getElementById(location.hash.slice(1))
  if (!el) return true
  window.scrollTo(0, 0)
  window.setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100)
  return false
}
